export const PATH_AUTH = {
  login: "/auth",
};